import Layout from "../../../../global/component/Genericos/Layout/Layout";
import { ButtonQR, Container, QRTitle } from "./localStyle";
import { BarcodeScanner } from "@awesome-cordova-plugins/barcode-scanner";
import { showToaster } from "../../../../global/context/action/toaster/toaster";
import { useContext } from "react";
import ToasterV2 from "../../../../global/component/Genericos/Toaster/ToasterV2";
import { GlobalContext } from "../../../../global/context/Provider";

const LectorQR = () => {
  
  // contexto global del Toaster
  const { toasterDispatch, toasterState } = useContext(GlobalContext);

  const escanear = async () => {
    const data = await BarcodeScanner.scan();
    
    showToaster(
      {
        texto: "Codigo QR leído exitosamente",
        tipo: "success",
      },
      "centroArriba"
    )(toasterDispatch);
    
  };

  return (
    <>
      {toasterState.toaster.show && <ToasterV2 />}
      <Layout>
        <Container>
          <QRTitle>Presione el botón para escanear el codigo QR</QRTitle>
          <ButtonQR className="bgc-latex30" onClick={escanear}>
            <p className="botonQr-text rb16b">Escanear</p>
          </ButtonQR>
        </Container>
      </Layout>
    </>
  );
};

export default LectorQR;
